import type { IsoDatum } from './typen'

/**
 * Datumsrechnung auf ISO-Tagen.
 *
 * Bewusst ohne Zeitzone und ohne Uhrzeit: Fuer den Scheduler zaehlt nur der
 * Kalendertag. Alle Funktionen sind rein, das aktuelle Datum wird immer
 * hereingereicht. Anders waeren die Tests nicht deterministisch, und ein
 * Scheduler, der sich nur um Mitternacht falsch verhaelt, ist der schlimmste
 * Fall von allen.
 */

export function alsIso(datum: Date): IsoDatum {
  const jahr = datum.getFullYear()
  const monat = String(datum.getMonth() + 1).padStart(2, '0')
  const tag = String(datum.getDate()).padStart(2, '0')
  return `${jahr}-${monat}-${tag}`
}

export function heute(): IsoDatum {
  return alsIso(new Date())
}

export function plusTage(datum: IsoDatum, tage: number): IsoDatum {
  const teile = datum.split('-').map(Number)
  const jahr = teile[0] ?? 1970
  const monat = teile[1] ?? 1
  const tag = teile[2] ?? 1
  // Der Date-Konstruktor rollt Monats- und Jahreswechsel selbst korrekt um,
  // inklusive Schaltjahren. Mittags statt Mitternacht, damit ein eventueller
  // Zeitzonenversatz den Tag nicht kippt.
  const d = new Date(jahr, monat - 1, tag + tage, 12, 0, 0)
  return alsIso(d)
}

/** Liegt `datum` am selben Tag oder frueher als `grenze`? */
export function istFaellig(datum: IsoDatum, grenze: IsoDatum): boolean {
  return datum <= grenze
}

export function tageZwischen(von: IsoDatum, bis: IsoDatum): number {
  const zuZeit = (d: IsoDatum) => {
    const teile = d.split('-').map(Number)
    return new Date(teile[0] ?? 1970, (teile[1] ?? 1) - 1, teile[2] ?? 1, 12).getTime()
  }
  return Math.round((zuZeit(bis) - zuZeit(von)) / 86_400_000)
}
